module.exports = __webpack_public_path__ + "media/images/e-bilet/Hero_Image_Kyiv_720-c0a0941b6c90753484a689395d8cc025.webp";